import { i18nMark } from 'lingui-react';

const messages = {
  assetLocation: i18nMark('Asset Location'),
  distanceToServiceLocation: i18nMark('Distance to Service Location'),
  notAvailable: i18nMark('Not Provided'),
  title: i18nMark('Location'),
  unit: i18nMark('Unit #{unitNumber}'),
};

export default messages;



// WEBPACK FOOTER //
// ./compositions/LocationWidget/messages.js